/** 只使用正文图片，排除编辑器表情并按出现顺序去重。 */
export const getBodyCoverImages = (html: string): string[] => {
  const doc = new DOMParser().parseFromString(html || '', 'text/html');
  return Array.from(new Set(Array.from(doc.querySelectorAll('img:not([data-emoji])'))
    .filter(image => !image.classList.contains('emoji-img'))
    .map(image => image.getAttribute('src')?.trim() || '')
    .filter(src => !!src && /^(https?:|blob:|data:image\/|\/)/i.test(src))));
};

export const readCoverFile = (file: File): Promise<string> => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result as string);
  reader.onerror = () => reject(new Error('图片读取失败，请重试'));
  reader.onabort = () => reject(new Error('图片读取已取消'));
  reader.readAsDataURL(file);
});
